import { createI18n } from "vue-i18n";
import { messages } from "./index";

export const supportedLocales = ["en", "es"];
const LOCALE_STORAGE_KEY = "destinatarium.locale";

export function normalizeLocale(locale) {
  if (typeof locale !== "string") return null;

  const language = locale.trim().toLowerCase().split(/[-_]/)[0];
  return supportedLocales.includes(language) ? language : null;
}

export function detectBrowserLocale() {
  if (typeof navigator === "undefined") return "en";

  const primaryBrowserLocale = navigator.language
    || (Array.isArray(navigator.languages) ? navigator.languages[0] : null);

  return normalizeLocale(primaryBrowserLocale) === "es" ? "es" : "en";
}

export function getStoredLocale() {
  if (typeof localStorage === "undefined") return null;

  try {
    return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch {
    return null;
  }
}

const initialLocale = getStoredLocale() || detectBrowserLocale();

export const i18n = createI18n({
  locale: initialLocale,
  fallbackLocale: "en",
  messages,
});

export function setLocale(locale) {
  const normalizedLocale = normalizeLocale(locale);
  if (!normalizedLocale) return false;

  const globalLocale = i18n.global.locale;
  if (globalLocale && typeof globalLocale === "object" && "value" in globalLocale) {
    globalLocale.value = normalizedLocale;
  } else {
    i18n.global.locale = normalizedLocale;
  }
  if (typeof localStorage !== "undefined") {
    try {
      localStorage.setItem(LOCALE_STORAGE_KEY, normalizedLocale);
    } catch {
      // The active locale still applies when browser storage is unavailable.
    }
  }
  if (typeof document !== "undefined") {
    document.documentElement.lang = normalizedLocale;
  }
  return true;
}

setLocale(initialLocale);
